<template>
  <div class="view">
    <div class="header-container">
      <div class="view-gabarit">
        <h2>{{ $t('exportSection.header') }}</h2>
      </div>
    </div>
    <div class="form-container">
      <div class="view-gabarit">
        <div class="view-content">
          <div class="details-box">
            <h3>{{ pagination }}. {{ $t('exportSection.sitesTitle') }}</h3>
            <p class="baseline">{{ $t('exportSection.sitesBaseline') }}</p>
          </div>
          <div class="form-gabarit">
            <div class="form-block">
              <div class="fieldset">
                <p class="subtitle">{{ $t('actualSites', actualSites.length) }}</p>
                <fieldset v-for="site in actualSites" :key="site.id" class="site-gabarit">
                  <input :id="`actual-site-${site.id}`" v-model="site.enabled" type="checkbox" />
                  <label :class="{ disabled: atLeastOneActualSite.length <= 1 && site.enabled }" :for="`actual-site-${site.id}`">
                    <b>{{ site.name }}</b>
                    <span>{{ site.address }}</span>
                  </label>
                </fieldset>
              </div>
            </div>
            <div class="form-block">
              <div class="fieldset">
                <p class="subtitle">{{ $t('futureSite', 2) }}</p>
                <fieldset v-for="site in targetSites" :key="site.id" class="site-gabarit">
                  <input :id="`actual-site-${site.id}`" v-model="site.enabled" type="checkbox" />
                  <label :for="`actual-site-${site.id}`">
                    <b>{{ site.name }}</b>
                    <span>{{ site.address }}</span>
                  </label>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="view-gabarit">
        <div class="cta-container">
          <button class="study-button" @click="() => previousStep()">{{ $t('previous') }}</button>
          <button class="study-button main" @click="() => nextStep()">{{ $t('continue') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ExportType from '@/pure/ExportType';

export default {
  computed: {
    ...mapGetters(['currentExport']),

    actualSites() {
      return this.currentExport.sites.filter(site => site.type === 1);
    },

    atLeastOneActualSite() {
      return this.actualSites.filter(site => site.enabled);
    },

    targetSites() {
      return this.currentExport.sites.filter(site => site.type === 2);
    },

    pagination() {
      return this.currentExport.type === ExportType.Simplified ? 1 : 2;
    },
  },

  methods: {
    getActiveSites() {
      return this.currentExport.sites.filter(site => site.enabled).map(site => site.id);
    },

    previousStep() {
      this.$router.push({ name: this.currentExport.type === ExportType.Simplified ? 'studyList' : 'exportFilters' });
    },

    nextStep() {
      const id = this.$route.params.studyId;
      const payload = {
        sites_id: this.getActiveSites(),
        status: 3,
      };
      this.$store
        .dispatch('patchExport', {
          id,
          payload,
        })
        .then(() => {
          this.$router.push({ name: 'exportTransportMode' });
        });
    },
  },
};
</script>

<style scoped lang="scss">
label {
  &.disabled {
    pointer-events: none;
  }
}
</style>
